import React,{useEffect, useState} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Link,useParams,useNavigate } from "react-router-dom";
import { clearErrors, updateVendorProduct, getProductDetails } from "../../actions/productAction";
import { useAlert } from "react-alert";
import { Button } from "@material-ui/core";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DescriptionIcon from "@material-ui/icons/Description";
import StorageIcon from "@material-ui/icons/Storage";
import SpellcheckIcon from "@material-ui/icons/Spellcheck";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import MetaData from '../../components/MetaData';
import { getAllCategories } from "../../actions/categoryAction";
import Loader from "../Loader";
// import Sidebar from "./Sidebar";
import { UPDATE_VENDOR_PRODUCT_RESET } from "../../constants/productConstant";
import { Editor } from '@tinymce/tinymce-react';

const VendorUpdateProduct = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {id} = useParams();
	const alert = useAlert();

	const { error, product } = useSelector((state) => state.productDetails);
	const { categories } = useSelector((state) => state.categories);
	const { loading, error: updateError, isUpdated } = useSelector((state) => state.product);

	const [category, setCategory] = useState("");
	const [name, setName] = useState("");
	const [topic, setTopic] = useState("");
	const [duration, setDuration] = useState("");
	const [type, setType] = useState("");
	const [price, setPrice] = useState(0);
	const [vat, setVat] = useState(0);
	const [status, setStatus] = useState("");
	const [speaker, setSpeaker] = useState('');
	const [tag, setTag] = useState("");
	const [syllabus, setSyllabus] = useState('');
	const [description, setDescription] = useState("");
	// const [Stock, setStock] = useState(0);
	// const [qty, setQty] = useState(0);
	const [images, setImages] = useState([]);
	// const [imagesPreview, setImagesPreview] = useState([]);

	const handleEditorChange = (content) => {
	    setDescription(content);
	};

	const handleEditorChangeSyllabus = (content) => {
	    setSyllabus(content);
	};

	// const categories = [
	//   "wall-tiles",
	//   "floor-tiles",
	//   "bathroom-tiles",
	//   "outdoor-tiles",
	//   "brick-&-metro tiles",
	//   "mosaic-tiles",
	// ];

	useEffect(() => {

		if (product && product._id !== id) {
	      dispatch(getProductDetails(id));
	    } else {
	      setCategory(product.category);
	      setName(product.name);
	      setTopic(product.topic);
	      setDuration(product.duration);
	      setType(product.type);
	      setStatus(product.status);
	      setDescription(product.description);
	      setPrice(product.price);
	      setVat(product.vat);
	      // setStock(product.Stock);
	      setTag(product.tag);
	      setSpeaker(product.speaker);
	      setSyllabus(product.syllabus);
	      setImages(product.images);
	    }

	    if (error) {
	      alert.error(error);
	      dispatch(clearErrors());
	    }

	    if (updateError) {
	      alert.error(updateError);
	      navigate("/vendor/products");
	      dispatch(clearErrors());
	    }
	    
	    if (isUpdated) {
	      alert.success("Product Updated Successfully");
	      navigate("/vendor/products");
	      dispatch({ type: UPDATE_VENDOR_PRODUCT_RESET });
	    }
	    dispatch(getAllCategories());
	}, [dispatch, alert, error, navigate, id, isUpdated, product, updateError]);

	const updateProductSubmitHandler = (e) => {
	    e.preventDefault();

	    const myForm = new FormData();

	    // Append all selected images
		  if (images && images.length > 0) {
		    images.forEach((image) => {
		      myForm.append("images", image);
		    });
		  }

	    myForm.set("category", category);
	    myForm.set("name", name);
	    myForm.set("topic", topic);
	    myForm.set("duration", duration);
	    myForm.set("type", type);
	    myForm.set("status", status);
	    myForm.set("price", price);
	    myForm.set("vat", vat);
	    myForm.set("description", description);
	    // myForm.set("Stock", Stock);
	    myForm.set("speaker", speaker);
	    myForm.set("syllabus", syllabus);
	    // myForm.set("qty", Stock);
	    myForm.set("tag", tag);

	    // images.forEach((image) => {
	    //   myForm.append("images", image);
	    // });
	    dispatch(updateVendorProduct(id, myForm));
	};

	const updateProductImagesChange = (e) => {
	     const filesArray = Array.from(e.target.files);
  setImages(filesArray);
	};

	return (
		<>
			{loading ? (
        <Loader />
      ) : (
      	<>

		      		<div className="dashboard-panel">
					<div className="container">
						<MetaData title={`Create Course`} />
						<div className="row">
							{/*<Sidebar />	*/}
							<div className="col-lg-9 col-md-8">
								<div className="dashboardContainer">
							        <h3>Update Course</h3>
							        <div className="col-12">
		                    			<form
							            className="createProductForm"
							            encType="multipart/form-data"
							            onSubmit={updateProductSubmitHandler}
							          >
							          	<div className="single-form">
							              <label>
							              	Awarding Body
							              </label>
							              <select value={category} onChange={(e) => setCategory(e.target.value)}>
							                <option value="">Select</option>
							                {categories && categories.map((item) => (
							                  <option key={item._id} defaultValue={item.name}>
							                    {item.name}
							                  </option>
							                ))}
							              </select>
							            </div>
							            <div className="single-form">
							              <label>Course Name</label>
							              <input
							                type="text"
							                placeholder="Course Name"
							                required
							                value={name}
							                onChange={(e) => setName(e.target.value)}
							              />
							            </div>
							            <div className="single-form">
							              <label>
							              	Subject
							              </label>
							              <input
							                type="text"
							                placeholder="Subject"
							                required
							                value={topic}
							                onChange={(e) => setTopic(e.target.value)}
							              />
							            </div>
							         	<div className="single-form">
							              <label>
							              	Duration
							              </label>
							              <input
							                type="text"
							                placeholder="Duration in months"
							                required
							                value={duration}
							                onChange={(e) => setDuration(e.target.value)}
							              />
							            </div>
							            <div className="single-form">
							              <label>
							              	Delivery Method
							              </label>
							              <select value={type} onChange={(e) => setType(e.target.value)}>
							                <option value="">Choose Type</option>
							                <option value="online">Online</option>
							                <option value="classroom">Classroom</option>
							                <option value="hybrid">Hybrid</option>
							              </select>
							            </div>
							            
							            <div className="single-form">
							              <label>
							              	Course Price
							              </label>
							              <input
							                type="number"
							                placeholder="Price"
							                required
							                value={price}
							                onChange={(e) => setPrice(e.target.value)}
							              />
							            </div>
							            <div className="single-form">
							              <label>
							              	VAT
							              </label>
							              <select value={vat} onChange={(e) => setVat(e.target.value)}>
							                <option value="">Choose Type</option>
							                <option value="0">0</option>
							                <option value="5">5</option>
							                <option value="20">20</option>
							              </select>
							            </div>
							            {/*<div className="single-form">
							              <label>
							              	Course Stock
							              </label>
							              <input
							                type="number"
							                placeholder="Stock"
							                required
							                value={Stock}
							                onChange={(e) => setStock(e.target.value)}
							              />
							            </div>*/}

							            <div className="single-form">
							              <label>
							              	Course Status
							              </label>
							              <select value={status} onChange={(e) => setStatus(e.target.value)}>
							                <option value="">Choose Status</option>
							                <option value="show">Show</option>
							                <option value="hide">Hide</option>
							              </select>
							            </div>

							            <div className="single-form">
							              <label>
							              	Delivered by
							              </label>
							              <select value={speaker} onChange={(e) => setSpeaker(e.target.value)}>
							                <option value="">Choose Speaker</option>
							                <option value="salman">Salman</option>
							                <option value="hasnain">Hasnain</option>
							                <option value="asad">Asad</option>
							              </select>
							            </div>

							            <div className="single-form">
							              <label>
							              	Course Tag
							              </label>
							              <select value={tag} onChange={(e) => setTag(e.target.value)}>
							                <option value="">Choose Tag</option>
							                <option value="course">Course</option>
							                <option value="latest">Latest Course</option>
							                <option value="featured">Featured Course</option>
							              </select>
							            </div>

							            <div className="single-form">
							              <label>
							              	Course Syllabus
							              </label>
							              {/*<textarea
							                placeholder="Syllabus"
							                value={syllabus}
							                onChange={(e) => setSyllabus(e.target.value)}
							                cols="10"
							                rows="1"
							              ></textarea>*/}
							              <Editor 
							              	apiKey='511npkfmj2oio25sykoybbl32gny8yfwq0zbl3m5zrkzqoz7'
							              	value={syllabus}
							              	init={{
												height: 500,
												menubar: true,
												plugins: [
													'advlist autolink lists link image charmap print preview anchor',
													'searchreplace visualblocks code fullscreen',
													'insertdatetime media table paste code help wordcount'
												],
												toolbar:
													'undo redo | formatselect | bold italic backcolor | \
				                                    alignleft aligncenter alignright alignjustify | \
				                                    bullist numlist outdent indent | removeformat | help',
				                                    image_uploadtab: true,
											        image_advtab: true, // Enable advanced tab for images
											        file_picker_types: 'image',
											        automatic_uploads: true,
											}}
											onEditorChange={handleEditorChangeSyllabus}
							              />
							            </div>

							            <div className="single-form">
							              <label>
							              	Course Description
							              </label>
							              {/*<textarea
							                placeholder="Course Description"
							                value={description}
							                onChange={(e) => setDescription(e.target.value)}
							                cols="10"
							                rows="1"
							              ></textarea>*/}
							              <Editor 
							              	apiKey='511npkfmj2oio25sykoybbl32gny8yfwq0zbl3m5zrkzqoz7'
							              	value={description}
							              	init={{
												height: 500,
												menubar: true,
												plugins: [
													'advlist autolink lists link image charmap print preview anchor',
													'searchreplace visualblocks code fullscreen',
													'insertdatetime media table paste code help wordcount'
												],
												toolbar:
													'undo redo | formatselect | bold italic backcolor | \
				                                    alignleft aligncenter alignright alignjustify | \
				                                    bullist numlist outdent indent | removeformat | help',
				                                    image_uploadtab: true,
											        image_advtab: true, // Enable advanced tab for images
											        file_picker_types: 'image',
											        automatic_uploads: true,
											}}
											onEditorChange={handleEditorChange}
							              />
							            </div>

							            <div className="single-form" id="createProductFormFile">
							              <input
							                type="file"
							                accept="image/*"
							                onChange={updateProductImagesChange}
							                multiple
							              />
							            </div>

							            {/*<div id="createProductFormImage">
							              {oldImages &&
							                oldImages.map((image, index) => (
							                  <img key={index} src={image.url} alt="Old Product Preview" />
							                ))}
							            </div>

							            <div className="single-form" id="createProductFormImage">
							              {imagesPreview.map((image, index) => (
							                <img key={index} src={image} alt="Product Preview" />
							              ))}
							            </div>*/}

							            <button
							            className="mt-2 btn btn-primary btn-hover-dark paymentFormBtn"
							              id="createProductBtn"
							              type="submit"
							              disabled={loading ? true : false}
							            >
							              Create
							            </button>
							          </form>
		  						    </div>
							    </div>
							</div>
						</div>
					</div>
					</div>
</>
		)}
		      	
		</>
	)
}

export default VendorUpdateProduct